import { isFormEmpty } from '../../utils/is-form-empty.util';

export const checkIfIsAddressEmpty = <A extends object>(
  address: A | null | undefined,
): address is null | undefined => {
  if (!address) {
    return true;
  }

  const postalInfo = 'postalInfo' in address ? address.postalInfo : undefined;
  const locationInfo =
    'locationInfo' in address ? address.locationInfo : undefined;
  const cadastralInfo =
    'cadastralInfo' in address ? address.cadastralInfo : undefined;

  if (!postalInfo && !locationInfo && !cadastralInfo) {
    return true;
  }

  if (
    isFormEmpty({ node: postalInfo }) &&
    isFormEmpty({ node: locationInfo }) &&
    isFormEmpty({ node: cadastralInfo })
  ) {
    return true;
  }

  return false;
};
